import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { UntilDestroy } from "@ngneat/until-destroy";
import { DisplayPdfFrameQuoteService } from "../../../../core/services/display-pdf-frame-quote.service";
import { CommonModule } from "@angular/common";
import { SelectModule } from "primeng/select";
import { EmailTemplates } from "../../../../core/models/orders/emailTemplates";
import { CheckboxChangeEvent, CheckboxModule } from "primeng/checkbox";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@UntilDestroy()
@Component({
  selector: "jni-po-email-header-quote",
  templateUrl: "./po-email-header-quote.component.html",
  styleUrls: ["./po-email-header-quote.component.scss"],
  imports: [
    CommonModule,
    SelectModule,
    ReactiveFormsModule,
    CheckboxModule,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class PoEmailHeaderQuoteComponent implements OnInit {
  @Input() parent!: FormGroup;
  @Input() templates: EmailTemplates[] = [];
  @Input() poNumber: string[] = [];
  @Input() formErrors!: Record<string, string>;
  @Input() validationMessages!: Record<string, Record<string, string>>;
  @Input() poNumberRevision: string[] = [];
  @Output() fetchVendorInformation = new EventEmitter();
  @Output() templateSelectedEvent = new EventEmitter();
  @Output() logValidationErrorsEvent = new EventEmitter();
  @Output() waterMarkPdfEvent = new EventEmitter();

  rush = "Rush";
  revised = "Revised";
  rushRevised = "Rush/Revised";
  rushCheck = false;
  revisedCheck = false;
  additionalSubject = "";

  constructor(private _displayPdfFrameService: DisplayPdfFrameQuoteService) {}

  ngOnInit(): void {
    this.onRevised();
  }

  logValidationErrors() {
    this.logValidationErrorsEvent.emit();
  }

  onRevised() {
    this._displayPdfFrameService.selectedRevised$.subscribe(value => {
      this.onRevisedSelection(value ?? ({} as CheckboxChangeEvent));
    });
  }

  onPONumberSelection() {
    this.parent.patchValue({
      header: {
        subject: `Nadel Proposal - ${
          this.parent.get(["header", "proposalNumber"])?.value || ""
        }`,
      },
    });
    this.fetchVendorInformation.emit(
      this.parent.get(["header", "proposalNumber"])?.value || ""
    );
  }

  clearRushRevisedField() {
    this.parent.patchValue({
      header: {
        rush: false,
        revised: false,
        additionalSubject: "",
      },
    });
    this.rushCheck = false;
    this.revisedCheck = false;
    this.additionalSubject = "";
  }

  onTemplateSelection() {
    this.templateSelectedEvent.emit(
      this.parent.get(["header", "templateId"])?.value || 0
    );
  }

  // onRushSelection(event: any) {
  //   this.rushCheck = event.target.checked;
  //   if (this.rushCheck && this.revisedCheck) {
  //     this.patchValueInSubject(this.rushRevised, this.additionalSubject);
  //   } else {
  //     if (this.rushCheck && !this.revisedCheck) {
  //       this.patchValueInSubject(this.rush, this.additionalSubject);
  //     } else if (!this.rushCheck && this.revisedCheck) {
  //       this.patchValueInSubject(this.revised, this.additionalSubject);
  //     } else if (!this.rushCheck && !this.revisedCheck) {
  //       this.patchValueInSubject('', this.additionalSubject);
  //     }
  //   }
  // }

  onRevisedSelection(event: CheckboxChangeEvent) {
    if (event) {
      this.revisedCheck = event.checked;
    }
    if (this.rushCheck && this.revisedCheck) {
      this.patchValueInSubject(this.rushRevised, this.additionalSubject);
    } else {
      if (this.rushCheck && !this.revisedCheck) {
        this.patchValueInSubject(this.rush, this.additionalSubject);
      } else if (!this.rushCheck && this.revisedCheck) {
        this.patchValueInSubject(this.revised, this.additionalSubject);
      } else if (!this.rushCheck && !this.revisedCheck) {
        this.patchValueInSubject("", this.additionalSubject);
      }
    }
    this.waterMarkPdfEvent.emit(this.revisedCheck);
  }

  patchValueInSubject(value: string, additionalSubject: string) {
    if (value && !additionalSubject) {
      this.parent.patchValue({
        header: {
          subject: `Nadel Proposal - ${
            this.parent.get(["header", "proposalNumber"])?.value || ""
          } - ${value}`,
        },
      });
    } else if (value && additionalSubject) {
      this.parent.patchValue({
        header: {
          subject: `Nadel Proposal - ${
            this.parent.get(["header", "proposalNumber"])?.value || ""
          } - ${value} - ${additionalSubject}`,
        },
      });
    } else if (!value && additionalSubject) {
      this.parent.patchValue({
        header: {
          subject: `Nadel Proposal - ${
            this.parent.get(["header", "proposalNumber"])?.value || ""
          } - ${additionalSubject}`,
        },
      });
    } else {
      this.parent.patchValue({
        header: {
          subject: `Nadel Proposal - ${
            this.parent.get(["header", "proposalNumber"])?.value || ""
          }`,
        },
      });
    }
  }

  onAdditionalSubject(event: Event) {
    const target = event.target as HTMLInputElement;
    this.additionalSubject = target?.value;
    if (this.additionalSubject) {
      if (this.rushCheck && this.revisedCheck) {
        this.patchValueInSubject(this.rushRevised, this.additionalSubject);
      } else {
        if (this.rushCheck && !this.revisedCheck) {
          this.patchValueInSubject(this.rush, this.additionalSubject);
        } else if (!this.rushCheck && this.revisedCheck) {
          this.patchValueInSubject(this.revised, this.additionalSubject);
        } else if (!this.rushCheck && !this.revisedCheck) {
          this.patchValueInSubject("", this.additionalSubject);
        }
      }
    } else {
      this.additionalSubject = "";
      if (this.rushCheck && this.revisedCheck) {
        this.patchValueInSubject(this.rushRevised, this.additionalSubject);
      } else {
        if (this.rushCheck && !this.revisedCheck) {
          this.patchValueInSubject(this.rush, this.additionalSubject);
        } else if (!this.rushCheck && this.revisedCheck) {
          this.patchValueInSubject(this.revised, this.additionalSubject);
        } else if (!this.rushCheck && !this.revisedCheck) {
          this.patchValueInSubject("", this.additionalSubject);
        }
      }
    }
  }
}
